import { useForm } from '../../contexts/FormContext'

function HeaderActions() {
  const { lastSaved, clearFormData } = useForm()

  const getTimeSinceLastSave = () => {
    if (!lastSaved) return null
    const savedDate = new Date(lastSaved)
    const now = new Date()
    const diffMs = now - savedDate
    const diffSecs = Math.floor(diffMs / 1000)
    const diffMins = Math.floor(diffMs / 60000)

    if (diffSecs < 10) return 'just now'
    if (diffSecs < 60) return `${diffSecs}s ago`
    if (diffMins < 60) return `${diffMins}m ago`
    return savedDate.toLocaleTimeString()
  }

  const handleClearProgress = () => {
    if (confirm('Are you sure you want to clear all your progress? This cannot be undone.')) {
      clearFormData()
    }
  }

  if (!lastSaved) return null

  return (
    <div className="layout-header-actions">
      <div className="last-saved-indicator">
        <span className="save-icon">💾</span>
        <span className="save-text">Saved {getTimeSinceLastSave()}</span>
      </div>
      <button className="clear-progress-btn" onClick={handleClearProgress}>
        Clear Progress
      </button>
    </div>
  )
}

export default HeaderActions
